import type { OpsiSelect } from '@/components/Input'
import { useApi } from './useApi'
import { useAuth } from './auth'
import type { Akun, JenisTagihan } from './types'

export function keOpsi<T>(
  items: T[] | null | undefined,
  fn: (item: T) => OpsiSelect,
): OpsiSelect[] {
  return (items ?? []).map(fn)
}

/** Opsi unit dari penugasan pengguna yang sedang masuk. */
export function useOpsiUnit(): OpsiSelect[] {
  const { unit } = useAuth()
  return unit.map((u) => ({ value: u.unitId, label: `${u.code} — ${u.name}` }))
}

export function namaUnitDari(unit: OpsiSelect[] | undefined, unitId: string | null | undefined): string {
  if (!unitId) return '-'
  const u = (unit ?? []).find((x) => x.value === unitId)
  return u ? u.label : unitId
}

/** Akun dari bagan akun (COA). */
export function useOpsiAkun(opsi?: { hanyaPostable?: boolean; tipe?: string }): {
  opsi: OpsiSelect[]
  daftar: Akun[]
  memuat: boolean
  galat: string | null
  muat: () => void
} {
  const hasil = useApi<unknown>('/accounts', { perPage: 500, sortBy: 'code', sortDir: 'asc' })
  const daftar = Array.isArray(hasil.data)
    ? (hasil.data as Akun[])
    : Array.isArray((hasil.data as { items?: Akun[] } | null)?.items)
      ? ((hasil.data as { items?: Akun[] }).items as Akun[])
      : []

  const tersaring = daftar.filter((a) => {
    if (opsi?.hanyaPostable && !a.isPostable) return false
    if (opsi?.tipe && a.accountType !== opsi.tipe) return false
    return true
  })

  return {
    opsi: tersaring.map((a) => ({ value: a.id, label: `${a.code} — ${a.name}` })),
    daftar: tersaring,
    memuat: hasil.memuat,
    galat: hasil.galat,
    muat: hasil.muat,
  }
}

/** Jenis tagihan (fee types). */
export function useOpsiJenisTagihan(): {
  opsi: OpsiSelect[]
  daftar: JenisTagihan[]
  memuat: boolean
  galat: string | null
  muat: () => void
} {
  const hasil = useApi<unknown>('/fee-types', { perPage: 200 })
  const daftar = Array.isArray(hasil.data)
    ? (hasil.data as JenisTagihan[])
    : Array.isArray((hasil.data as { items?: JenisTagihan[] } | null)?.items)
      ? ((hasil.data as { items?: JenisTagihan[] }).items as JenisTagihan[])
      : []
  return {
    opsi: daftar.map((f) => ({ value: f.id, label: `${f.code} — ${f.name}` })),
    daftar,
    memuat: hasil.memuat,
    galat: hasil.galat,
    muat: hasil.muat,
  }
}
